import getWrappedUseQuery from "api/helpers/getWrappedUseQuery";
import apiClient from "api-client";

import KEYS from "../keys";

const useSeminarTypesQuery = getWrappedUseQuery(KEYS.GET_SEMINAR_TYPES, apiClient.ForumSeminarType.getAll);

export { useSeminarTypesQuery };
